import { forwardRef } from "react";
import { Image, ImageProps } from "@chakra-ui/react";

/**
 * An Image component that prevents right-click context menu (save image as).
 * Use this for content images that need piracy protection (comic covers, pages, etc.)
 */
export const ProtectedImage = forwardRef<HTMLImageElement, ImageProps>(
  (props, ref) => {
    return (
      <Image {...props} ref={ref} onContextMenu={(e) => e.preventDefault()} />
    );
  },
);

ProtectedImage.displayName = "ProtectedImage";
